import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/components/Login'
import MainPage from '@/components/MainPage'
import TeamPage from '@/components/TeamPage'
import SciencePage from '@/components/SciencePage'
import OpportunityPage from '@/components/OpportunityPage'
import InnovationPage from '@/components/InnovationPage'
import InvestingPage from '@/components/InvestingPage'
import ContactPage from '@/components/ContactPage'
// import ComingSoon from '@/components/ComingSoon'
// import CalendarPage from '@/components/GoogleCalendar'
import _ from 'underscore'

Vue.use(Router)

export default new Router({
  mode: 'history',
  hash: false,
  routes: [
    // {
    //   path: '/',
    //   name: 'ComingSoon',
    //   component: ComingSoon,
    //   props: true
    // },
    // {
    //   path: '*',
    //   beforeEnter: (to, from, next) => {
    //     // Reroute based on expected inputs
    //     var r = [
    //       'home',
    //       'team',
    //       'science',
    //       'opportunity',
    //       'innovation',
    //       'investing',
    //       'contact',
    //       'employee',
    //       'investor',
    //       'new-investor',
    //       'newinvestor',
    //       'invest',
    //       'new'
    //     ]
    //     var t = to.path.substring(1).trim()
    //     if (_.contains(r, t)) {
    //       // console.log('Routing to', '/' + t + '/top')
    //       var host = window.location.host
    //       var parts = host.split('.')
    //       var len = parts.length
    //       if (2 < len) {
    //         host = parts[len - 2] + '.' + parts[len - 1]
    //       }
    //       // Handle switching sub-domains.
    //       switch (t) {
    //         case 'employee': {
    //           window.location.replace(window.location.protocol + '//employee.' + host)
    //           break
    //         }
    //         case 'investor': {
    //           window.location.replace(window.location.protocol + '//investor.' + host)
    //           break
    //         }
    //         case 'new-investor':
    //         case 'newinvestor':
    //         case 'invest':
    //         case 'new': {
    //           window.location.replace(window.location.protocol + '//new-investor.' + host)
    //           break
    //         }
    //         default: {
    //           // window.location.replace(window.location.protocol + '//' + host)
    //           next('/' + t + '/top')
    //         }
    //       }
    //     } else {
    //       // console.log('Garbage in = NO OP!')
    //       next(false)
    //     }
    //   }
    // },
    {
      path: '/',
      redirect: {name: 'Home'}
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage,
      props: true
    },
    {
      path: '/home/:section',
      name: 'Home',
      component: MainPage,
      props: true
    },
    {
      path: '/team/:section',
      name: 'Team',
      component: TeamPage,
      props: true
    },
    {
      path: '/science/:section',
      name: 'Science',
      component: SciencePage,
      props: true
    },
    {
      path: '/opportunity/:section',
      name: 'Opportunity',
      component: OpportunityPage,
      props: true
    },
    {
      path: '/innovation/:section',
      name: 'Innovation',
      component: InnovationPage,
      props: true
    },
    {
      path: '/investing/:section',
      name: 'Investing',
      component: InvestingPage,
      props: true
    },
    {
      path: '/contact/:section',
      name: 'Contact',
      component: ContactPage,
      props: true
    }
    // {
    //   path: '/calendar/:section',
    //   name: 'Calendar',
    //   component: CalendarPage,
    //   props: true
    // }
    // {
    //   path: '/public',
    //   name: 'Downloads',
    //   props: false
    // }
  ]
})
